// This needs to partially match the entries in the backend's ExportTypeEnum
export enum ReportType {
  AdequacyServicingProvider = "adequacyServicingProvider",
  // AllSpecialties
  AdequacyAggregate = "adequacyAggregate",
  ZipSummary = "zipSummary",
  // no compare mode option
  ClosestProvidersToMembers = "closestProvidersToMembers",
  AdequacySpecialtySummary = "adequacySpecialtySummary",
  StateSummary = "stateSummary",
  CountySummary = "countySummary",
  SpecialtySummaryByCounty = "specialtySummaryByCounty",
  ZipAnalysisAdequacyServicingProvider = "zipAnalysisAdequacyServicingProvider",
  ZipAnalysisResultsReport = "zipAnalysisResultsReport",
  ZipClassAggregateResultsReport = "zipClassAggregateResultsReport",

  RegionSummary = "regionSummary",
  RegionSummaryComparison = "regionSummaryComparison",
  StateSummaryComparison = "stateSummaryComparison",
  CountySummaryComparison = "countySummaryComparison",
  SpecialtySummaryByCountyComparison = "specialtySummaryByCountyComparison",
  ZipSummaryComparison = "zipSummaryComparison",
  AdequacySpecialtySummaryComparison = "adequacySpecialtySummaryComparison",
  AdequacyAggregateComparison = "adequacyAggregateComparison",
  AdequacyServicingProviderComparison = "adequacyServicingProviderComparison",
  ZipAnalysisAdequacyServicingProviderComparison = "zipAnalysisAdequacyServicingProviderComparison",
  ZipClassAggregateResultsReportComparison = "zipClassAggregateResultsReportComparison",
  ZipAnalysisResultsReportComparison = "zipAnalysisResultsReportComparison",
  ProviderHubServicingProviderReport = "providerHubServicingProviderReport",

  AdequacyBulkTerminationVolumeTermProjectDetails = "adequacyBulkTerminationVolumeTermProjectDetails",
  AdequacyBulkTerminationChangedGaps = "adequacyBulkTerminationChangedGaps",
  AdequacyBulkTerminationSpecialtySummaryComparison = "adequacyBulkTerminationSpecialtySummaryComparison",
  AdequacyBulkTerminationProviders = "adequacyBulkTerminationProviders",
  AdequacyBulkTerminationDistinctProviders = "adequacyBulkTerminationDistinctProviders",
  ZipAdequacyBulkTerminationChangedGaps = "zipAdequacyBulkTerminationChangedGaps",
  ZipAdequacyBulkTerminationSpecialtySummaryComparison = "zipAdequacyBulkTerminationSpecialtySummaryComparison",

  AdequacyBulkVolumeTargetProjectDetails = "adequacyBulkVolumeTargetProjectDetails",
  AdequacyBulkTargetChangedGaps = "adequacyBulkTargetChangedGaps",
  AdequacyBulkTargetSpecialtySummaryComparison = "adequacyBulkTargetSpecialtySummaryComparison",
  AdequacyBulkTargetUploadFile = "adequacyBulkTargetUploadFile",
  AdequacyBulkTargetProviders = "adequacyBulkTargetProviders",
  AdequacyBulkTargetDistinctProviders = "adequacyBulkTargetDistinctProviders",
  ZipAdequacyBulkTargetChangedGaps = "zipAdequacyBulkTargetChangedGaps",
  ZipAdequacyBulkTargetSpecialtySummaryComparison = "zipAdequacyBulkTargetSpecialtySummaryComparison",
  SpecialtySummaryByZipBulk = "specialtySummaryByZipBulk",
  ZipClassAggregateResultsReportBulk = "zipClassAggregateResultsReportBulk",
  ZipAnalysisServicingProviderBulk = "zipAnalysisServicingProviderBulk",
}